<template>
  <div class="side-edit-content p-5">
    <strong class="title-main">{{ $t('views.seller.integrations.config.edit.title') }}</strong>
    <p class="subtitle d-block mt-3 mb-4">
      {{ $t('views.seller.integrations.config.edit.product') }}:
      <strong> {{ editGroupData.product_name }}</strong>
    </p>

    <!-- Exibe URL -->
    <div :class="isInputError('update_url')" @click="removeError('update_url')">
      <strong class="title-medium">{{ $t('views.seller.integrations.config.edit.url.title') }}</strong>
      <div class="d-flex bd-highlight">
        <div class="flex-grow-1 bd-highlight">
          <b-form-group id="fieldset-url" label-for="input-url">
            <b-form-input id="input-url" :placeholder="`Informe a URL do ${integration.name}`" class="form-input" v-model="editGroupUrl" trim></b-form-input>
          </b-form-group>
        </div>
        <div class="bd-highlight">
          <b-button class="btn-outline btn-send-test ml-2" variant="primary" @click="sendTest" :disabled="loadingTest || blockingTest">
            <template v-if="loadingTest">
              <b-spinner variant="primary" class="mr-2" small></b-spinner>
              {{ $t('views.seller.integrations.config.edit.url.sending') }}
            </template>
            <template v-else>
              <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.8435 0.618489C14.6536 0.460578 14.4246 0.357086 14.1806 0.319026C13.9366 0.280965 13.6869 0.309761 13.458 0.402349L1.51077 5.22592C1.25527 5.33104 1.03778 5.51138 0.887165 5.74299C0.736554 5.97461 0.659944 6.24656 0.667502 6.52273C0.675061 6.79891 0.76643 7.06626 0.929484 7.28929C1.09254 7.51233 1.31956 7.6805 1.58043 7.77149L3.9971 8.61198L5.3441 13.0664C5.3624 13.1259 5.38897 13.1826 5.42302 13.2347C5.42818 13.2427 5.43547 13.2486 5.44097 13.2564C5.4803 13.3113 5.52784 13.3598 5.58192 13.4002C5.5973 13.412 5.61203 13.4229 5.62847 13.4334C5.69175 13.4753 5.76184 13.506 5.83562 13.5241L5.84351 13.5248L5.84799 13.5267C5.89234 13.5357 5.93749 13.5403 5.98275 13.5403C5.98711 13.5403 5.99097 13.5383 5.99529 13.5382C6.06359 13.537 6.1313 13.5252 6.19601 13.5033C6.21107 13.4982 6.22397 13.4896 6.23857 13.4834C6.28682 13.4634 6.33254 13.4378 6.37476 13.4071C6.40858 13.3786 6.44241 13.3501 6.47624 13.3216L8.27769 11.3327L10.9645 13.4141C11.2011 13.5982 11.4922 13.6983 11.792 13.6986C12.1061 13.6982 12.4106 13.5898 12.6543 13.3916C12.898 13.1934 13.0661 12.9174 13.1306 12.61L15.3057 1.9323C15.355 1.69197 15.338 1.44277 15.2566 1.21135C15.1752 0.979936 15.0324 0.775006 14.8435 0.618489ZM6.2471 8.82422C6.15466 8.91629 6.09147 9.03361 6.06546 9.16146L5.85912 10.1641L5.33641 8.43542L8.04658 7.02412L6.2471 8.82422ZM11.7816 12.36L8.60647 9.90037C8.47363 9.79772 8.307 9.74889 8.13977 9.76361C7.97254 9.77833 7.81699 9.85552 7.70413 9.9798L7.12719 10.6166L7.33108 9.62563L12.0531 4.90363C12.1658 4.79107 12.2345 4.64187 12.2467 4.48304C12.2588 4.32422 12.2138 4.16629 12.1195 4.03784C12.0253 3.9094 11.8882 3.81894 11.7331 3.78285C11.5779 3.74677 11.415 3.76744 11.2738 3.84113L4.49693 7.36955L2.01403 6.46094L13.9997 1.666L11.7816 12.36Z" fill="#0854C5"/>
              </svg>
              {{ $t('views.seller.integrations.config.edit.url.send') }}
            </template>
          </b-button>
        </div>
      </div>
      <span class="show-error">
        {{ showError('update_url') }}
        <template v-if="sugestionRedirect.url">
          <br />
          {{ $t('views.seller.integrations.config.edit.url.sugestion_1') }}
          {{ sugestionRedirect.name }}
          {{ $t('views.seller.integrations.config.edit.url.sugestion_2') }}
          <a :href="`/integracoes/${sugestionRedirect.url}`" @click.stop>
            {{ $t('views.seller.integrations.config.edit.url.sugestion_3') }}
            {{ sugestionRedirect.name }}.
          </a>
        </template>
      </span>
    </div>

    <!-- Lista payloads -->
    <div :class="isInputError('update_payloads')" @click="removeError('update_payloads')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">{{ $t('views.seller.integrations.config.edit.payload.title') }}</strong>
        <a href="#" @click.prevent="selectAllEdit()" class="select-all float-right">
          {{ editGroupVariables?.length > 0 ? $t('views.seller.integrations.config.edit.payload.remove_all') : $t('views.seller.integrations.config.edit.payload.select_all') }}
        </a>
      </div>
      <multiselect 
        v-model="editGroupVariables" 
        :options="variable.items" 
        :multiple="true" 
        :taggable="false"
        :show-labels="false" 
        :clear-on-select="false" 
        :close-on-select="false"
        :limit-text="limitText" 
        :limit="4"
        :searchable="true"
        :group-select="true"
        class="new-style"
        group-values="options"
        group-label="group"
        :placeholder="$t('views.seller.integrations.config.edit.payload.search')"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="option__title" v-if="props.option?.$isLabel">
            {{ props.option.$groupLabel.name }}
            <span class="label-info label-info--deselected">{{ $t('views.seller.integrations.config.edit.payload.select_all') }}</span>
            <span class="label-info label-info--selected">{{ $t('views.seller.integrations.config.edit.payload.remove_all') }}</span>
          </span>
          <span class="d-flex option__item" :class="props.option.$isDisabled && 'option__item_disabled'" v-else>
            <img :src="isOptionSelectedEdit(props.option.id, props.option.$isDisabled)" />
            {{ props.option.name }}
          </span>
        </template>
        <template #placeholder>
          <span class="select-title">{{ $t('views.seller.integrations.config.edit.payload.select') }}</span>
        </template>
        <span slot="noResult">{{ $t('views.seller.integrations.config.edit.payload.no_content') }}</span>
        <div slot="limit" class="multiselect__tag limit">+{{ editGroupVariables?.length - 4 }}</div>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('update_payloads') }}</span>
    </div>

    <!-- Lista eventos -->
    <div :class="isInputError('update_events')" @click="removeError('update_events')">
      <strong class="title-medium mt-4">{{ $t('views.seller.integrations.config.edit.event.title') }}</strong>
      <span class="show-error">{{ showError('update_events') }}</span>
      <div class="d-flex bd-highlight my-3">
        <div class="flex-fill bd-highlight">
          <switch-group :label="$t('views.seller.integrations.config.edit.event.label.sales')" v-model="editGroupEvents" :options="events.options_sales" />
        </div>
        <div class="flex-fill bd-highlight">
          <switch-group :label="$t('views.seller.integrations.config.edit.event.label.contracts')" v-model="editGroupEvents" :options="events.options_contracts" />
        </div>
      </div>
      <switch-group :label="$t('views.seller.integrations.config.edit.event.label.recovery')" v-model="editGroupEvents" :options="events.options_sales_recovery" />
    </div>

  </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import SwitchGroup from '@/components/shared/forms/SwitchGroup';
import CallbackService from '@/services/resources/CallbackService';

export default {
  name: "IntegrationsConfigUpdateWebhook",
  components: {
    Multiselect,
    SwitchGroup
  },
  props: {
    opendEdit: {
      type: Boolean,
      required: true
    },
    loadingUpdate: {
      type: Boolean,
      required: true
    },
    editGroupLoad: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Webhook' })
    },
    products: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [
          {
            group: {
              name: '',
            },
            options: [],
          }
        ],
      })
    },
    variable: {
      type: Object,
      required: true,
      default: () => ({
        value: null,
        items: [],
      })
    },
    events: {
      type: Object,
      required: true,
      default: () => ({
        options_sales: [],
        options_contracts: [],
        options_sales_recovery: []
      })
    },
    mountPayload: {
      type: Function,
      required: true
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    sugestionRedirect: {
      type: Object,
      required: true,
      default: () => ({
        url: null,
        name: null,
      })
    },
    removeError: {
      type: Function,
      required: true
    },
    removeErrors: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
    limitText: {
      type: Function,
      required: true
    },
    organizePayloadsByGroup: {
      type: Function,
      required: true
    },
    organizeEvents: {
      type: Function,
      required: true
    },
  },
  watch: {
    editGroupUrl() {
      if (!this.disableWatcherTest) {
        this.blockingTest = true;
      }
    },
    editGroupVariables() {
      if (!this.disableWatcherTest) {
        this.blockingTest = true;
      }
    },
    editGroupEvents() {
      if (!this.disableWatcherTest) {
        this.blockingTest = true;
      }
    }
  },
  data: () => ({
    loadingTest: false,
    editGroupData: {},
    editGroupUrl: '',
    editGroupVariables: [],
    editGroupEvents: [],
    blockingTest: false,
    disableWatcherTest: false,
  }),
  methods: {
    showEditCallback(data) {

      this.removeErrors([
        'update_url',
        'update_payloads',
        'update_events'
      ]);

      this.disableWatcherTest = true;
      this.editGroupData = data;
      this.editGroupUrl = data.url;
      this.editGroupVariables = [];
      this.editGroupEvents = [];

      this.$emit('update:opendEdit', true);
      this.$emit('update:editGroupLoad', true);
      this.$emit('update:loadingUpdate', false);
      this.$emit('update:productSelected', data.product_id);

      const encodedURL = encodeURIComponent(data.url);
      CallbackService.build().search({
        url: `integrations/group/${this.integration.id}/${data.product_id}?url=${encodedURL}`
      })
      .then(response => {
        this.editGroupVariables = this.mountPayload(response.payloads);
        this.editGroupEvents = response.events;
        this.blockingTest = false;

        this.$emit('update:editGroupLoad', false);

        this.$nextTick(() => {
          // Reativa os watchers após a próxima renderização
          this.disableWatcherTest = false;
        });
      })
      .catch((err) => {
        this.$emit('update:opendEdit', false);
      });
    },
    async updateCallbacks(data) {

      this.$emit('update:loadingUpdate', true);

      try {

        const force = data?.force_update || false;

        const url_base = (force) ? data.dataUpdate.url : this.editGroupData.url;
        const url = (force) ? data.dataUpdate.url : this.editGroupUrl;
        const payloads = (force) ? data.dataUpdate.payloads : this.organizePayloadsByGroup(this.editGroupVariables.map(item => item.id));
        const events = (force) ? data.dataUpdate.events : this.organizeEvents(this.editGroupEvents);

        const products = (force) ? data.products : data;

        const promises = products.map(async (product) => {

          const product_id = (force) ? product.product_id : product;
          
          return CallbackService.build().update({
            url_base,
            url,
            payloads,
            events
          }, `integrations/group/${this.integration.id}/${product_id}`, { suppressErrorNotify: true });
        });

        await Promise.all(promises);

        this.$emit('update:opendEdit', false);
        this.fetchCallbacks();

        const message = products.length > 1 ?
          this.$t('views.seller.integrations.config.toast.update.success.message_multiple') :
          this.$t('views.seller.integrations.config.toast.update.success.message');

        this.$bvToast.toast(message, {
          title: this.$t('views.seller.integrations.config.toast.update.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

      } catch(err) {
        this.mountInputError(err.response.data, 'update_');
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
            title: this.$t('views.seller.integrations.config.toast.update.error.title'),
            variant: "danger",
            autoHideDelay: 5000,
            appendToast: true,
        });
        
      } finally {
        this.$emit('update:loadingUpdate', false);
      }
    },
    isOptionSelectedEdit(option, force) {
      return this.editGroupVariables?.find(item => item.id === option) || force
        ? require('@/assets/img/icons/checkbox-area-selected.svg')
        : require('@/assets/img/icons/checkbox-area.svg');
    },
    selectAllEdit() {
      if (this.editGroupVariables.length > 0) {
        this.editGroupVariables = [];
      } else {
        let allOptions = [];
        this.variable.items.forEach(item => {
          allOptions = allOptions.concat(item.options);
        });
        this.editGroupVariables = allOptions;
      }
    },
    sendTest() {
      this.loadingTest = true;
      CallbackService.build().update({
        url: this.editGroupUrl
      }, `integrations/group/${this.integration.id}/${this.editGroupData.product_id}/test`)
      .then(() => {
        this.loadingTest = false;
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.test.success.message'), {
          title: `${this.$t('views.seller.integrations.config.toast.test.success.title')} ${this.integration.name}`,
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });
      })
      .catch(err => {
        this.mountInputError(err.response.data);
        this.loadingTest = false;
      });
    },
  }
}
</script>